import { Col, Form, Input, InputNumber, Row, Select, Upload } from 'antd';
import { useEffect, useRef, useState, } from 'react'
import { httpGet } from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';
import TextArea from 'antd/es/input/TextArea';
import systemExpand from '../../../config/systemExpand';
import FilesManage from '../../filesSystem/FilesManage';


export default function BuyerEdit(props: any) {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    const [buyerTypeData, setBuyerTypeData] = useState<any>();
    const [imageUrl, setImageUrl] = useState<string>();

    const [bb, setBa] = useState<any>();

    const uploadButton = (
        <div>

            <div style={{ marginTop: 8 }}>营业执照</div>
        </div>
    );
    /** 后端数据Service */
    let wmService: any = "";
    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'buyer'
    };
    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            ref.current.row.then((res: any) => {
                if (typeof res === 'undefined') return;

                setImageUrl(res.data.businessLicenseUrl)

            })
        }
        const fetchData = async () => {
            httpGet(wmService, {
                apiId: "buyerType",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setBuyerTypeData(res.data)
                }
            })
            let data = await systemExpand.filesServer2();
            const { apiServiceUrl, serviceId } = data;
            let uploadData = await FilesManage.upload(apiServiceUrl!, serviceId!, "documentLicenseFiles", { successCallback: returnBackData })
            setBa(uploadData)
        }
        fetchData()
    }, [])
    const returnBackData = (data: any) => {        
        form.setFieldValue("businessLicenseUrl", data.data.destination+"/"+ data.data.fileName)
    }
    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps}></WebEditUniversal>
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '采购商'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={"60%"}
            >

                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >
                    <Row>
                        <Col span={8}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="专属id"
                                name="selfId"
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="采购商名称"
                                name="buyerName"
                                rules={[{ required: true, message: '请输入采购商名称!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="采购商电话"
                                name="buyerPhone"
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="采购商类型"
                                name="buyerTypeId"
                                rules={[{ required: true, message: '采购商类型!' }]}>
                                <Select
                                    showSearch
                                    placeholder="采购商类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(buyerTypeData, 'buyerTypeName')}
                                </Select>
                            </Form.Item>

                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="联系人"
                                name="contact"
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="加密时长"
                                name="buyerCodeTime">
                                <InputNumber  />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="地址"
                                name="address"
                            >
                                <TextArea
                                    placeholder="地址"
                                    autoSize={{ minRows: 2, maxRows: 5 }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label=""
                                name="businessLicenseUrl"

                            >
                                <Upload
                                    maxCount={1}
                                    {...bb}
                                    listType="picture-card"
                                >
                                    {imageUrl ? <img width={"100%"} src={imageUrl} alt="avatar" /> : uploadButton}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                </Form>
            </AntDraggableModal>

        </>
    )
}
